import { EnvironmentInterface } from './environment.interface';
import { FlagEnum } from '../../../modules/src/lib/core/enums/flag.enum';
import { SeverityTypeEnum } from '../../../modules/src/lib/core/enums/severity-type.enum';

export const environment: EnvironmentInterface = {
  name: 'production',
  production: true,
  apiUrl: 'https://api.optitax.ca',
  auth0Audience: 'https://api.optitax.ca',
  isDebug: false,
  clientPortal: {
    host: 'https://client.optitax.ca',
  },
  stripe: {
    publishableKey: 'pk_live_51IkDdSBKIUB9oaXJtcAELlxfMV7xoWDMBjjgCswTMccmrTq6XqfcjXHH1VuohnyrBtnFMrOavci7v8lm2U9No4oG00TYrC5X2X',
    publishableKeyTest: 'pk_test_51IkDdSBKIUB9oaXJd3vaLLpbnC8JDVq1elejABpYHhDEsIFzQ5PqEjvTR8O93DsdvbQWeEkZ9d9ex8uejWwUpvTa00AA60NnTK',
  },
  logging: {
    severityType: SeverityTypeEnum.Warning,
  },
  flags: {
    [FlagEnum.Calculations]: true,
    [FlagEnum.CalculationsCreate]: true,
    [FlagEnum.CalculationsList]: true,
    [FlagEnum.CalculationsSection84_1]: true,
    [FlagEnum.CalculationsRollover]: true,
    [FlagEnum.CalculationsRRQ]: false,
    [FlagEnum.CalculationsSalaryDividend]: true,
    [FlagEnum.CalculationsRrsp]: false,
    [FlagEnum.ClientQuestionnaires]: true,
    [FlagEnum.ClientQuestionnairesCreate]: true,
    [FlagEnum.ClientQuestionnairesList]: true,
    [FlagEnum.ClientQuestionnairesQuebec2022TaxForm]: false,
    [FlagEnum.ClientQuestionnairesQuebec2023TaxForm]: true,
    [FlagEnum.SalaryDividendTaxForm]: false,
  },
  magieno: {
    observabilityApiKey: 'c8a520ef-42cd-4ca4-9009-1faaa5e3b181:13r9vdd8k3o1wtjccs3hjt',
  },
};
